import useMount from '@picsart/rc/useMount';
import { LandingCategory } from 'constants/enums';
import { customPageOpenEvents } from 'constants/main';
import useAnalytics from 'services/Analytics';

const useFirePageOpen = (
  screenName: string,
  customEventName: string,
  category: LandingCategory,
) => {
  const { firePageOpen, fireEvent } = useAnalytics();

  useMount(() => {
    if (category === LandingCategory.partnership || !customEventName) {
      firePageOpen(screenName, category);
    } else {
      const customEvent = customPageOpenEvents.get(customEventName);
      fireEvent(customEventName, customEvent);
    }
  });
};

export default useFirePageOpen;
